import { Logo } from '@kanda-libs/ks-design-library';

import LayoutV2 from 'components/LayoutV2';
import { UserX } from 'lucide-react';

const Login: React.FunctionComponent = function () {
  return (
    <LayoutV2>
      <div className="w-full py-12 md:py-20">
        <div className="flex flex-col p-4 py-8 md:p-12 w-full max-w-3xl mx-auto bg-neutral-000 border border-neutral-300 rounded-xl text-center gap-y-4">
          <UserX size={64} className="mx-auto text-red-200" />
          <h1 className="text-24-28-em">You are not currently logged in</h1>
          <h2 className="text-16-24">
            To access your quotes on Kanda, please follow the link contained in
            the email from Kanda
          </h2>
          <Logo width={200} height={50} className="mx-auto w-40 mt-4" />
        </div>
      </div>
    </LayoutV2>
  );
};

export default Login;
